import { ActivatedRoute } from '@angular/router';
import { AdminService } from './../../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guardian-group-index',
  templateUrl: './guardian-group-index.component.html',
  styleUrls: ['./guardian-group-index.component.css']
})
export class GuardianGroupIndexComponent implements OnInit {

  dtOptions: DataTables.Settings = {}
  subscriptionGroupList:[] = undefined
  loading = false
  server_user_id=0

  constructor(private adminService:AdminService, private activeRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading = true
    this.activeRoute.params.subscribe(
  x=>{
    this.server_user_id = x['server_user_id']
    this.adminService.getSubscriptionGroupsByGuardian(this.server_user_id).subscribe(
      value=>{
        this.loading = false

        this.subscriptionGroupList = value
      }
    )

  }
)

  }

}


